<template>
  <header class="bg-white flex flex-wrap items-center shadow-md sticky top-0 z-20">

    <div class="mx-4 my-2">
      <router-link to="/dashboard" class="">
        <img v-show="showLogo" :src="logo" style="height: 40px"/>
      </router-link>
    </div>

    <nav class="menu flex flex-wrap order-last md:order-none"
         :class="{ visible: isMainActive, hidden: !isMainActive }">

      <ul class="menu-items w-screen md:w-auto md:border-t-0 md:flex">
        <li class="menu-item">
          <accordion ref="accordion2">
            <span slot="link" class="menu-title">Marketing <i class="fa fa-angle-down md:hidden"></i></span>
            <ul slot="dropdown" class="submenu-item">
              <li><a class="menu-link" :href="`${cpixdomain}/aspen/accountAgentFlyer.htm`" v-show="!hidePresentationFlyer()">Presentation Flyer</a></li>
              <li><a class="menu-link" :href="`${cpixdomain}/aspen/manageqr.htm?style=account`">QR Codes</a></li>
              <!--              <li><a class="menu-link" :href="`${cpixdomain}/adminReports/youTubeStats.htm?type=realtor&realtorId=${realtorId}`">YouTube Stats</a></li>-->
              <li><a class="menu-link" :href="`${cpixdomain}/aspen/ssRedirect.php`" v-show="!hideMarketingMaterials()">Self-Serve Tour</a></li>
              <li><a class="menu-link" :href="`${cpixdomain}/tour/agent.htm?agentid=${realtorId}`">Agent Gallery</a></li>
            </ul>
          </accordion>
        </li>

        <li class="menu-item">
          <accordion ref="accordion3">
            <span slot="link" class="menu-title">Social Media <i class="fa fa-angle-down md:hidden"></i></span>
            <ul slot="dropdown" class="submenu-item">
              <li><a class="menu-link" :href="`${cpixdomain}/aspen/socialMediaDashboard.htm?objectType=Realtor`">Dashboard</a></li>
              <li><a class="menu-link" :href="`${cpixdomain}/aspen/socialSetupWizardConnect.htm?wiz=true&step=1`">Setup</a></li>
              <li><a class="menu-link" :href="`${cpixdomain}/aspen/manualPosting.htm`">Create A Post</a></li>
              <li><a class="menu-link" :href="`${cpixdomain}/aspen/facebookPendingPost.htm?objectType=Realtor`"><span ignore>FB</span> Pending Posts</a></li>
            </ul>
          </accordion>
        </li>

        <li class="menu-item" v-show="companyAdmin">
          <accordion ref="accordion4">
            <span slot="link" class="menu-title">Manage Company <i class="fa fa-angle-down md:hidden"></i></span>
            <ul slot="dropdown" class="submenu-item">
              <li><a class="menu-link" :href="`${cpixdomain}/aspen/officeSelect.htm`" v-if="showOffices()">Select Office</a></li>
              <li><a class="menu-link" :href="`${cpixdomain}/aspen/socialMediaDashboard.htm?objectType=Company`">Social Media</a></li>
              <li v-if="showCompanyContractLicenses()">
                <a class="menu-link" :href="`${cpixdomain}/aspen/companySMLicense.htm`">Contract Licenses</a>
              </li>
              <li><a class="menu-link" :href="`${cpixdomain}/aspen/companyAddAgent.htm`">Add New Agent</a></li>
              <li><a class="menu-link" :href="`${cpixdomain}/aspen/autoPrintSuite.htm?type=company`" v-show="!hideMarketingMaterials()">Print Suite</a></li>
              <li><a class="menu-link" :href="`${cpixdomain}/aspen/companyReports.htm?`">Reports</a></li>
              <li v-if="!!me.tokenUser.company.flags.SHOW_MANAGE_SHORT_CODES_PAGE">
                <a class="menu-link" :href="`${cpixdomain}/aspen/adminShortCodeCompany.htm?`">Short Codes</a>
              </li>
              <li><a class="menu-link" :href="`${cpixdomain}/aspen/invoiceSelect.htm?type=company`">View/Print Invoices</a></li>
              <li v-if="showLeadBee()">
                <a class="menu-link" :href="`${cpixdomain}/aspen/adminLeadBeeExtensions.htm`">Manage <span ignore>Leadbee</span> Ext</a>
              </li>
              <li><a class="menu-link" :href="`${cpixdomain}/aspen/fixRealtorEmails.htm?type=company`">Email Manager</a></li>
              <li><a class="menu-link" :href="`${cpixdomain}/aspen/emailPrefAdmin.php?type=Company`">Edit Notifications</a></li>
              <li><a class="menu-link" :href="`${cpixdomain}/aspen/lobbyDisplay.htm`">Lobby Listing Display</a></li>
            </ul>
          </accordion>
        </li>

        <li class="menu-item" v-show="officeAdmin">
          <accordion ref="accordion5">
            <span slot="link" class="menu-title">Manage Office <i class="fa fa-angle-down md:hidden"></i></span>
            <ul slot="dropdown" class="submenu-item">
              <li><a class="menu-link" :href="`${cpixdomain}/aspen/socialMediaDashboard.htm?objectType=Office`">Social Media</a></li>
              <li v-if="showOfficeContractLicenses()">
                <a class="menu-link" :href="`${cpixdomain}/aspen/officeSMLicense.htm`">Contract Licenses</a>
              </li>
              <li><a class="menu-link" :href="`${cpixdomain}/aspen/officeAddAgent.htm`">Add New Agent</a></li>
              <li><a class="menu-link" :href="`${cpixdomain}/aspen/officeReports.htm?`">Reports</a></li>
              <li><a class="menu-link" :href="`${cpixdomain}/aspen/autoPrintSuite.htm?type=office`" v-show="!hideMarketingMaterials()">Print Suite</a></li>
              <li v-if="showLeadBee()">
                <a class="menu-link" :href="`${cpixdomain}/aspen/adminLeadBeeExtensions.htm?type=office`">Manage <span ignore>Leadbee</span> Ext</a>
              </li>
              <li><a class="menu-link" :href="`${cpixdomain}/aspen/fixRealtorEmails.htm?type=office`">Email Manager</a></li>
              <li><a class="menu-link" :href="`${cpixdomain}/aspen/emailPrefAdmin.php?type=office`">Edit Notifications</a></li>
              <li><a class="menu-link" :href="`${cpixdomain}/aspen/lobbyDisplay.htm`">Lobby Listing Display</a></li>
            </ul>
          </accordion>
        </li>

      </ul>
    </nav>

    <div class="flex ml-auto mr-2 py-2 items-center">
      <a class="btn-green" :href="learningUrl" title="Learning Portal" target="_blank">
        <span class="">
          <i class="fa fa-graduation-cap text-white"></i>
          <span class="md:visible">Learning Portal</span>
         </span>
      </a>
      <a class="btn-green" href="https://support.insiderealestate.com/#lp-pom-block-173" v-show="hideSupportPortalBtn()" target="_blank" title="Support Center">
        <span class="bg-green">
          <svg aria-hidden="true" style="margin-top: 1px; width: 12px;" focusable="false" data-prefix="fas" data-icon="headset" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="svg-inline--fa fa-headset white"><path fill="currentColor" d="M192 208c0-17.67-14.33-32-32-32h-16c-35.35 0-64 28.65-64 64v48c0 35.35 28.65 64 64 64h16c17.67 0 32-14.33 32-32V208zm176 144c35.35 0 64-28.65 64-64v-48c0-35.35-28.65-64-64-64h-16c-17.67 0-32 14.33-32 32v112c0 17.67 14.33 32 32 32h16zM256 0C113.18 0 4.58 118.83 0 256v16c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-16c0-114.69 93.31-208 208-208s208 93.31 208 208h-.12c.08 2.43.12 165.72.12 165.72 0 23.35-18.93 42.28-42.28 42.28H320c0-26.51-21.49-48-48-48h-32c-26.51 0-48 21.49-48 48s21.49 48 48 48h181.72c49.86 0 90.28-40.42 90.28-90.28V256C507.42 118.83 398.82 0 256 0z" class=""></path></svg>
          <span class="md:visible">Support Center</span>
        </span>
      </a>
      <dropdown-link>
                <span slot="link" class="btn-dropdown-link">
                  <span class="mr-1"><i class="fas fa-cog nav-icon text-gray-500"></i> <span hidden> Config</span> </span>
                </span>
        <div slot="dropdown" class="flex flex-col bg-white shadow border overflow-hidden pt-2">
          <a class="btn-dropdown" :href="`${cpixdomain}/aspen/emailPref.htm`">Edit Notification</a>
          <a class="btn-dropdown" :href="`${cpixdomain}/aspen/invoiceSelect.htm?type=realtor`">View Order History</a>
          <a class="btn-dropdown" :href="`${cpixdomain}/aspen/accountStatsEmail.htm`">Account Automation</a>
          <!--<a class="dropdown-item" href="#">Manage My Account</a>-->
        </div>
      </dropdown-link>

      <dropdown-link>
                <span slot="link" class="btn-dropdown-link">
                  <span class="mr-1"><i class="fas fa-user-circle nav-icon text-success text-green-500"></i> <span hidden> Profile</span> </span>
                </span>
        <div slot="dropdown" class="flex flex-col bg-white shadow rounded border overflow-hidden ">
          <div class="px-2 py-2"><strong class="inline-block" ignore>{{agentName}}</strong></div>

          <div class="px-2 py-2" v-if="impersonatedName">
            <div>Acting as</div>
            <strong ignore>{{impersonatedName}}</strong>
          </div>

          <a class="btn-dropdown" :href="`${cpixdomain}/agentSetup/`">Agent Setup</a>
          <a class="btn-dropdown" :href="`${cpixdomain}/aspen/preferencesAgent.htm`">Agent Preferences</a>
          <a class="btn-dropdown" :href="`${cpixdomain}/aspen/accountInfo.htm`">Edit Agent Profile</a>
          <a class="btn-dropdown" :href="`${cpixdomain}/aspen/accountPref.htm`">Edit Username / password</a>
          <a v-show="this.isTokenUserAnyAdmin" class="btn-dropdown" :href="`${cpixdomain}/aspen/accountDelete.htm`">Delete Account</a>
          <a class="btn-dropdown" href="#" @click.prevent="logout">Log Out</a>
        </div>
      </dropdown-link>

      <button class="border-transparent flex navbar-burger p-3 rounded text-black-300
                            focus:border-transparent focus:outline-none
                            hover:bg-gray-200
                            md:hidden"
              @click="isMainActive = !isMainActive">
        <svg class="fill-current h-3 w-3" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
          <title>Menu</title>
          <path d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z"/>
        </svg>
      </button>

    </div>

  </header>
</template>

<script>
  import {AWS_URL, cpixdomain} from "../config";
  import {deleteCookie, getCookie} from "../cookie";
  import DropdownLink from '@/components/ui/dropdown-link'
  import Accordion from '@/components/ui/accordion'
  import {mapGetters} from 'vuex';

  export default {
    name: "NavbarMain",
    components: {
      DropdownLink,
      Accordion
    },
    data() {
      return {
        isMainActive: true,
        windowWidth: 0,
        showLogo: false
      }
    },
    computed: {
      ...mapGetters([
        'me',
        'isTokenUserAnyAdmin',
        'officeAdmin'
      ]),

      logo() {
        /* if company has a white label pref set use pref instead*/
        if (this.me.tokenUser.company.preferences[14]
          && this.me.tokenUser.company.preferences[14].PREFvalue
          && this.me.tokenUser.company.preferences[588]
          && Boolean(this.me.tokenUser.company.preferences[588].PREFvalue === "true")
        ) {
          return AWS_URL + this.me.tokenUser.company.preferences[14].PREFvalue
        }

        return require('../assets/icons/ListingMachineGreen.png')
      },

      cpixdomain() {
        return cpixdomain;
      },
      realtorId() {
        return this.me ? this.me.tokenUser.id : '';
      },
      isAdmin() {
        return getCookie('admin');
      },

      companyAdmin() {
        return getCookie('companyAdmin');
      },
      agentName() {
        return this.me.tokenUser.name;
      },
      impersonatedName() {
        return this.$helpers.get(['name'], this.me.impersonated);
      },
      learningUrl() {
        return this.me.tokenUser.learningUrl;
      },
      langCode() {
        if(typeof this.me.tokenUser.preferences !== 'undefined' && typeof this.me.tokenUser.preferences[719] !== 'undefined') {
          return this.me.tokenUser.preferences[719].PREFvalue;
        }
        return 'en';
      }
    },
    methods: {
      showCompanyContractLicenses() {
        return this.me.tokenUser.company.hasMembershipLicenses
      },
      showOfficeContractLicenses() {
        return this.me.tokenUser.office.hasMembershipLicenses
      },
      showLeadBee() {
        if (this.me.isImpersonated) {
          switch (this.me.impersonated.loggedInAs) {
            case 'company':
              return this.me.impersonated.flags.SHOW_MANAGE_LEADBEE_EXTENSIONS_PAGE
            case 'office':
            case 'realtor':
              return this.me.impersonated.company.flags.SHOW_MANAGE_LEADBEE_EXTENSIONS_PAGE
          }
        } else if (this.me.tokenUser) {
          return this.me.tokenUser.company.flags.SHOW_MANAGE_LEADBEE_EXTENSIONS_PAGE
        }
      },
      showOffices() {
        if (this.me.isImpersonated) {
          switch (this.me.impersonated.loggedInAs) {
            case 'company':
              return this.me.impersonated.offices.length
            case 'office':
              return this.me.impersonated.company.offices.length
            case 'realtor':
              return this.me.impersonated.company.offices.length
          }
        } else if (this.me.tokenUser) {
          return this.me.tokenUser.company.offices.length
        }
      },
      logout() {
        deleteCookie('token');
        deleteCookie('admin');
        window.location.href = cpixdomain + '/login.htm?out=true';
      },
      getWindowWidth() {
        this.windowWidth = document.documentElement.clientWidth;

        //set main menu to show based on break point
        this.isMainActive = this.windowWidth >= 768 //tailwind.theme.screens.md

        //show and hide accordions based off isMainActive
        Object.entries(this.$refs).forEach(([key, val]) => {
          if (/accordion\d+/mig.exec(key)) {
            this.isMainActive ? val.show() : val.hide()
          }
        });

      },
      changeIdentity(id) {
        // Show loading icon
        this.loading = true;
        let vm = this;

        // Call to update session
        this.$http.get('/switchUser/' + id).then(() => {
            // Hide loading icon
            vm.loading = false;
            console.log(getCookie('token'));
        });
      },
      hideMarketingMaterials() {
        if(typeof this.me.tokenUser.company.preferences[712] !== 'undefined') {
          return this.me.tokenUser.company.preferences[712].PREFvalue === "true";
        }

        return false;
      },
      hidePresentationFlyer() {
        if(typeof this.me.tokenUser.company.preferences[718] !== 'undefined' || this.hideMarketingMaterials()) {
          return this.me.tokenUser.company.preferences[718].PREFvalue === "true";
        }

        return false;
      },
      hideSupportPortalBtn() {
        if (this.langCode === 'fr-CA') {
          return false;
        }

        return true;
      }
    },
    mounted() {
      let vm = this;

      this.$nextTick(function () {
        var d = new Date();

        this.$store.dispatch('fetchMe')
          .then(() => {
            vm.showLogo = true;

            if(vm.me.tokenUser.isCompanyAdmin === false && vm.me.tokenUser.isOfficeAdmin === false) {
                this.changeIdentity(vm.me.tokenUser.id)
            }

            if(this.langCode != 'fr-CA') {
              vm.$intercom.boot({
                Agent_Halo_ID: vm.me.tokenUser.id,
                name: vm.me.tokenUser.name,
                email: vm.me.tokenUser.email,
                Product: 'PIXCombo',
                created_at: d.getTime(),
                SID: vm.me.tokenUser.company.SID
              });
            }

          })

        window.addEventListener('resize', this.getWindowWidth);

        //Init
        this.getWindowWidth()
      })
    },
    beforeDestroy() {
      window.removeEventListener('resize', this.getWindowWidth);
    }
  }
</script>

<style scoped lang="scss">
  @import "../assets/scss/variables";

  .menu {
    .menu-item {
      @apply p-4 border-l-4 border-transparent text-sm;

      &:hover {
        @apply border-green-500;
      }

      .menu-link {
        @apply text-gray-500;

        &:hover {
          @apply text-green-500;
        }
      }

      .menu-title {
        @apply whitespace-no-wrap;
      }

      .submenu-item {
        li {
          @apply pl-2 pt-1;
        }
      }
    }
  }

  .btn-green {
    padding:4px;
    background: #93c83e;
    border-radius: 2px;
    color: white;
    overflow: hidden;
    white-space: nowrap;
    margin: 0 5px 0 5px;
    font-size: 12px;
    span {
      padding-left: 0.5rem;
      padding-right: 0.5rem;
      svg {
        display: inherit;
      }
    }
  }

  @media (min-width: 768px) {
    .menu {
      @apply flex-1;

      .menu-items {
        @apply w-full;
        max-width: 900px;

        &:hover {
          .menu-item .submenu-item {
            @apply block;
          }
        }

        .menu-item {
          @apply relative flex-1 m-0;
          border-top: 4px solid transparent;
          border-left: 1px solid #eee;
          border-right: 1px solid transparent;

          &:hover {
            border-top: 4px solid $green;
            border-left: 1px solid #eee;

            .submenu-item {
              @apply shadow-md left-0 border-none absolute;

              &:hover {

                a {
                  @apply text-gray-900;

                  &:hover {
                    @apply text-green-500;
                  }
                }
              }
            }
          }

          .menu-title {
            @apply text-xs;
          }

          .submenu-item {
            @apply bg-white shadow-lg left-0 absolute border-t-0 hidden;
            min-height: 350px;
            width: calc(100% + 2px);
            top: 100%;

            li {
              @apply text-xs p-0;

              a {
                @apply px-2 mb-2;
              }
            }

            .menu-link {
              @apply block text-left w-full text-xs;
            }
          }
        }
      }
    }
  }
</style>